import script from "./AboutPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AboutPage.vue?vue&type=script&setup=true&lang=ts"

import "./AboutPage.vue?vue&type=style&index=0&id=2ad6c966&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ad6c966"]])

export default __exports__